module.exports = __webpack_public_path__ + "img/About 7636 pic1.d768cc02.jpg";